module.exports = __webpack_public_path__ + "img/logo_gifty.0d20fd54.svg";